// extracted by css-extract-rspack-plugin
export default {"root":"D5GSS"};